module.exports = __webpack_public_path__ + "img/about-top-banner.199bec41.png";